<template>
    <modal-frame noHeader @close-modal="$emit('close-modal')">
        <template #content>
            <div class="content">
                <h3>Bem-vindo(a) à plataforma de Educação Finaceira da Plano</h3>

                <p>
                    Nossa <strong>sugestão</strong> é que agende agora mesmo seu encontro com o
                    <strong>Educador Financeiro Pessoal</strong>, assim você terá 30 minutos de videoligação para
                    podermos ajudar no sucesso da sua Saúde Financeira e de modo personalizado. E também explicar como
                    você pode tirar o máximo proveito da plataforma.
                </p>

                <BasicButton label="Agende já" @click="goToAppointemnts" />
            </div>
        </template>
    </modal-frame>
</template>

<script setup>
import { useRouter } from 'vue-router'

import ModalFrame from '../../containers/ModalFrame.vue'
import BasicButton from '../buttons/BasicButton.vue'

const router = useRouter()

const emits = defineEmits(['close-modal'])

function goToAppointemnts() {
    router.push('agendamentos')
}
</script>

<style lang="scss">
.content {
    text-align: center;

    .basic-button {
        margin: 0 auto;
    }

    h3 {
        font-size: 16px;
        font-weight: bold;
    }

    p {
        font-size: 14px;
    }

    h3,
    p {
        margin-bottom: 24px;
        line-height: 24px;
    }
}
</style>
